import React, { useEffect, useState } from "react";
import { IonPage, IonContent, IonHeader, useIonViewWillEnter, IonLoading, IonGrid, IonRow, IonCol } from '@ionic/react';
import './PinCreatePage.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import KeyPad from "../../../components/KeyPad/KeyPad";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { Sep10ChallengeParams, WalletInfoState } from "../../../types/types";
import { useAppDispatch, useAppSelector } from "../../../services/redux/hook";
import { Networks } from "@stellar/stellar-sdk";
import { stellarApi } from "../../../services/api/stellar";
import { receivedSep10Token } from "../../../services/redux/slices/auth/sep10";

const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';
const isTestnet = import.meta.env.VITE_isTestnet === 'true';

const PinCreatePage: React.FC<any> = () => {

    const history = useHistory();
    const [pins, setPins] = useState(['', '', '', '', '', '']);
    const { t, i18n } = useTranslation();
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    const dispatch = useAppDispatch();
    const [showLoading, setShowLoading] = useState(false);


    useIonViewWillEnter(() => {

        const init = async () => {

            setPins(['', '', '', '', '', '']);

            setShowLoading(true)

            // here we generate the sep10 token for future use during the registration process
            // it should use the account wallet private key because for new generation the wallet
            // is still not multisig

            let params: Sep10ChallengeParams = {
                account: walletInfo.account_key as string,
                home_domain: ebioroAuthDomain,
                network: isTestnet ? Networks.TESTNET : Networks.PUBLIC,
                privateKey: walletInfo.account_private_key as string
            }

            try {

                const data = await dispatch(stellarApi.endpoints.sep10.initiate(params)).unwrap();

                if (data) {

                    dispatch(receivedSep10Token(data));
                }

            } catch (error) {

            } finally {
                setShowLoading(false)
            }

        }

        init()

    })


    const handleClick = (value: string) => {
        const temp = [...pins];
        const idx = temp.indexOf('');
        if (idx !== -1) {
            temp[idx] = value;
            setPins(temp);
        }
    };

    const handleRemove = () => {
        const temp = [...pins];
        const firstEmpty = temp.indexOf('');
        const idxToClear = firstEmpty === -1 ? temp.length - 1 : firstEmpty - 1;
        if (idxToClear >= 0) {
            temp[idxToClear] = '';
            setPins(temp);
        }
    };

    useEffect(() => {
        if (pins.every(d => d !== '')) {
            const inputCombination = pins.join("");
            history.push({
                pathname: '/pin/verify',
                state: { detail: { pin: inputCombination } }
            });
        }
    }, [pins, history]);

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <AppHeader
                    title={t('pin.create-pin.HEADER') as string}
                    goBack={true}
                />
            </IonHeader>

            <IonContent scrollY={false}>
                <IonLoading isOpen={showLoading} />

                <div className="ion-padding">
                    <p className="ion-text-center">{t('pin.create-pin.DIGIT-LABELTEXT-CONT')}</p>
                </div>

                <IonGrid className="pinlock-PIN">
                    <IonRow>
                        {pins.map((value, index) => (
                            <IonCol size="2" key={index} className="ion-text-center">
                                <div className={`${value !== '' ? 'pinlock-otp-input__active' : 'pinlock-otp-input'}`} />
                            </IonCol>
                        ))}
                    </IonRow>
                </IonGrid>

                <IonGrid>
                    <KeyPad handleClick={handleClick} handleRemove={handleRemove} compact />
                </IonGrid>

            </IonContent>



        </IonPage>
    )

}

export default PinCreatePage